"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeGeoTree = exports.getTreeByID = exports.getQueryParamByType = exports.flattenTree = exports.createStrictFillChecker = exports.createFillChecker = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _excluded = ["parent_id"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var _normalizeGeoTree = exports.normalizeGeoTree = function normalizeGeoTree(geoTree) {
  return R.map(R.pipe(function (_ref) {
    var parentID = _ref.parent_id,
      leaf = _objectWithoutProperties(_ref, _excluded);
    return R.mergeAll([leaf, {
      parentID: parentID
    }]);
  }, R.over(R.lensProp('children'), R.when(Boolean, _normalizeGeoTree))), geoTree);
};
var _getTreeByID = exports.getTreeByID = function getTreeByID(tree, id) {
  return R.reduceWhile(R.isNil, function (acc, item) {
    return item.id === id ? item : item.children ? _getTreeByID(item.children, id) : acc;
  }, null, tree);
};
var _flattenTree = exports.flattenTree = function flattenTree(tree) {
  return R.call(R.pipe(R.append(R.omit(['children'], tree)), R.when(R.always(tree.children), function (list) {
    return R.concat(list, R.map(_flattenTree, tree.children));
  }), R.flatten), []);
};
var createFillChecker = exports.createFillChecker = function createFillChecker(cities, districts, provinces) {
  return function (flattenedTree) {
    return R.any(function (_ref2) {
      var id = _ref2.id;
      return R.includes(id, cities) || R.includes(id, districts) || R.includes(id, provinces);
    }, flattenedTree);
  };
};
var createStrictFillChecker = exports.createStrictFillChecker = function createStrictFillChecker(cities, districts, provinces) {
  return function (flattenedTree) {
    return R.all(function (_ref3) {
      var id = _ref3.id;
      return R.includes(id, cities) || R.includes(id, districts) || R.includes(id, provinces);
    }, flattenedTree);
  };
};
var getQueryParamByType = exports.getQueryParamByType = function getQueryParamByType(type) {
  return R.call(R.cond([[R.equals('province'), R.always(_fn.QUERY_PARAMS.PROVINCES)], [R.equals('district'), R.always(_fn.QUERY_PARAMS.DISTRICTS)], [R.equals('city'), R.always(_fn.QUERY_PARAMS.CITIES)], [R.T, function () {
    return console.log("Current [".concat(type, "] dont allow"));
  }]]), type);
};